//* Importing the zod library for schema validation
import z from "zod";

export const responseDeletedSchema = z.object({
  result: z.boolean(),
  data: z.string(),
});

export const responseUpdateSchema = z.object({
  result: z.boolean(),
  data: z.any(),
  message: z.string(),
});

// Função genérica para criar response schema 
export const createResponseFullSchema = <T extends z.ZodTypeAny>(dataSchema: T) => 
  z.object({
    result: z.boolean(),
    data: dataSchema,
    message: z.string().optional(),
  });


export const apiErrorResponseSchema = z.object({
  result: z.literal(false),
  data: z.number(),
  error: z.object({
    message: z.string(),
    debug: z
      .object({
        file: z.string().optional(),
        line: z.number().optional(),
        trace: z.array(z.any()).optional(),
      })
      .optional(),
  }),
});

export type ApiErrorResponse = z.infer<typeof apiErrorResponseSchema>;
